// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1vl4a","info":"UpdateTermsInfo_info__2ldid"};